// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cde78544","86":"4d1ee8c8","101":"6b4a905d","138":"0e427f0e","140":"f8f35d12","147":"c47c3b5d","175":"68e934de","240":"3fe5589b","373":"72ed1378","464":"c2fd0bd2","472":"335edc81","503":"7658428d","741":"b304b67c","832":"235f5627","918":"9158750f"}[chunkId] + ".chunk.js";
};